module.exports = __webpack_public_path__ + "static/media/menu.dcd1725b.svg";